import React from "react";
import { scrollToContact } from "../Home/Hero";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    // Navigate to home and pass a 'scrollToContact' flag in the state
    navigate("/", { state: { scrollToContact: true } });
  };

  return (
    <section style={styles.hero}>
      <div style={styles.overlay}>
        <h1 style={styles.heading}>
          Blockchain & Digital Currency <br /> Consulting Services
        </h1>

        <p style={styles.subtext}>
          Explore our other services at CryptoConsultz
        </p>

        <button style={styles.button} onClick={handleBookNow}>
          Book Now
        </button>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    height: "60vh",
    backgroundImage: "url('services_bg.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },

  overlay: {
    textAlign: "center",
    color: "#fff",
    padding: "20px",
    background: "rgba(0,0,0,0.4)", // 🔥 subtle dark overlay for readability
    borderRadius: "8px",
  },

  heading: {
    fontSize: "46px",
    fontWeight: "800",
    lineHeight: "1.3",
    marginBottom: "20px",
  },

  subtext: {
    fontSize: "20px",
    marginBottom: "25px",
    fontWeight: "600",
    opacity: 1,
  },

  button: {
    padding: "12px 28px",
    backgroundColor: "#ff4da6", // pinkish
    color: "#fff",
    border: "none",
    borderRadius: "25px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default Hero;
